import { Box, Button, Card, Stack, Typography } from "@mui/joy";
export type MailLayout = "classic" | "bold" | "editorial";
export function MailLayoutPicker({
  value,
  onChange,
}: {
  value: MailLayout;
  onChange: (value: MailLayout) => void;
}) {
  return (
    <Stack spacing={1}>
      <Typography level="title-md">Choose a print layout</Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "repeat(3,minmax(0,1fr))" },
          gap: 1,
        }}
      >
        {(["classic", "bold", "editorial"] as const).map((layout) => (
          <Card key={layout} variant={layout === value ? "soft" : "outlined"}>
            <Box
              aria-hidden
              sx={{
                height: 130,
                bgcolor: "#fff",
                border: "1px solid",
                borderColor: "divider",
                p: 1.5,
                borderRadius: layout === "classic" ? 8 : 0,
              }}
            >
              <Box
                sx={{
                  height: 9,
                  width: 45,
                  bgcolor: layout === "editorial" ? "#273445" : "#31567b",
                  mb: 1.5,
                }}
              />
              <Typography
                sx={{
                  color: "#273445",
                  fontSize: 17,
                  lineHeight: 1.1,
                  fontFamily:
                    layout === "editorial" ? "Georgia,serif" : "inherit",
                  fontWeight: layout === "bold" ? 900 : 600,
                  textTransform: layout === "bold" ? "uppercase" : "none",
                }}
              >
                Your roof.
                <br />A clear plan.
              </Typography>
              <Box
                sx={{
                  height: 22,
                  bgcolor: "#e4eaf0",
                  mt: 1,
                  borderLeft:
                    layout === "bold" ? "6px solid #31567b" : undefined,
                }}
              />
              <Box
                sx={{ height: 5, width: "70%", bgcolor: "#d8dfe7", mt: 1 }}
              />
            </Box>
            <Typography level="title-sm">
              {layout === "classic"
                ? "Classic estimate"
                : layout === "bold"
                  ? "Bold offer"
                  : "Editorial letter"}
            </Typography>
            <Typography level="body-xs">
              {layout === "classic"
                ? "Rounded details and familiar hierarchy."
                : layout === "bold"
                  ? "Strong headings and squared accents."
                  : "Serif headings and restrained rules."}
            </Typography>
            <Button
              size="sm"
              variant={layout === value ? "solid" : "outlined"}
              onClick={() => onChange(layout)}
            >
              {layout === value ? "Selected" : "Use layout"}
            </Button>
          </Card>
        ))}
      </Box>
      <Typography level="body-xs">
        Illustrative thumbnails. Your brand and house details appear in the
        generated proof. Works with packets and postcards.
      </Typography>
    </Stack>
  );
}
